module.exports = __webpack_public_path__ + "plumbguide-logo.png?25a9ef2f56e5bf8ef279c93e9a62cc54";